import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Card from "../../Components/Cards/Card";
import useSellerApplication from "./useSellerApplication";

export default function () {
  const { reset, sellerApplicationFields } = useSellerApplication();
  const { id } = useParams();

  useEffect(() => {
    axios.get(`seller-applications/${id}`).then(res => {
      reset(res.data.sellerApplication);
    });
  }, []);

  return (
    <Card title="View seller application">
      <form className="form w-100 row">
        {sellerApplicationFields}
      </form>
    </Card>
  );
}